export type DialogButtonsChoice = 'CONFIRM' | 'YES' | 'NO' | 'CANCEL' | 'CLOSE';

export interface DialogButtonsConfig {
  buttonChoice: DialogButtonsChoice;
  buttonText?: string;
}
